import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';



export interface IProps {
  center?: boolean;
  disableDefaultMargins?: boolean;
}

export const FC = styled(Box, {
  shouldForwardProp: prop =>
    prop !== 'center' &&
    prop !== 'disableDefaultMargins'
})<IProps>(({theme, center, disableDefaultMargins}) => ({
  marginBottom: !disableDefaultMargins ? theme.spacing(3) : undefined,
  flex: '1 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: center ? 'center' : 'stretch'
}));
